<template>
  <div style="position:relative">
    <v-stage
      v-if="mockup !== null"
      :config="stageConfig"
      class="omcustom-product-image"
      :style="style"
    >
      <v-layer>
        <v-rect
          :config="{
            width: stageConfig.width / stageConfig.scale.x,
            height: stageConfig.height / stageConfig.scale.x,
            fill: '#ffffff'
          }"
        />
        <template v-for="l in mockup.layers">
          <group
            v-if="l.type === 'Group'"
            :layer="l"
            :key="l.id"
            :mockupID="mockup.id"
            :ratio="ratio"
          />
          <m-image
            v-if="l.type === 'Image'"
            :layer="l"
            :key="l.id"
            :mockupID="mockup.id"
          />
          <print-area
            v-if="l.type === 'Printarea'"
            :layer="l"
            :key="l.id"
            @loading="
              loading => {
                loadings = { ...loadings, [l.id]: loading }
              }
            "
            :ratio="ratio"
          />
        </template>
      </v-layer>
    </v-stage>
    <span style="display:none">{{ isMockupLoading }}</span>
  </div>
</template>
<script>
import Group from './Group'
import Image from './Image'
import PrintArea from './PrintArea'
import { mapGetters } from 'vuex'
import { map, get } from 'lodash'
import jQuery from 'jquery'
export default {
  components: {
    group: Group,
    'm-image': Image,
    PrintArea
  },
  props: {
    mockup: {
      type: Object
    },
    preview: {
      type: String
    }
  },
  data() {
    return {
      loadings: {}
    }
  },
  mounted() {
    jQuery('.konvajs-content')
      .removeClass('konvajs-content')
      .addClass('fabric-content')
  },
  computed: {
    ...mapGetters(['template', 'personalized', 'mockupLoadings']),
    ratio() {
      const { mockup } = this
      return mockup.width <= 1000 ? 1 : 1000 / mockup.width
    },
    stageConfig() {
      const { mockup, ratio } = this
      return {
        width: mockup.width * ratio,
        height: mockup.height * ratio,
        scale: { x: ratio, y: ratio },
        listening: false
      }
    },
    style() {
      return {
        position: 'relative',
        height: 0,
        paddingBottom: `${(this.mockup.height / this.mockup.width) * 100}%`
      }
    },
    isMockupLoading() {
      const mockupLoading = get(this.mockupLoadings, this.mockup.id, {})
      return map(mockupLoading).some(loading => loading === true)
    },
    isLoading() {
      return map(this.loadings).some(loading => loading === true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Mockup/Mockup.vue